import { TabPanel } from 'primereact/tabview'
import { Fieldset } from 'primereact/fieldset'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Btn,
  CustomCalendar,
  CustomCheckbox,
  CustomDropdown,
  CustomMultiSelect,
  CustomPanel,
  CustomTabView,
  InputText,
  NumeroDecimal,
  PageHeader,
  Periodo,
} from '../../../../../components'
import CustomCardColorBar from '../../../../../components/CustomCardColorBar/CustomCardColorBar'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import ClienteSemCoordenada from './ClienteSemCoordenada/ClienteSemCoordenada'
import useMapaCarregamento, { LOAD_MESSAGE } from './MapaCarregamentoHook'
import RoteirizacaoMapa from './RoteirizacaoMapa/RoteirizacaoMapa'
import {
  azul_escuro,
  azul_hover,
  gray,
  laranja,
  pink,
  vinho,
} from '../../../../../assets/js/colors'
import ModalDescarregarElement from '../../EnvioParaRota/ModalDescarregarElement'
import CustomCardDistance from '../../../../../components/CustomCardDistance/CustomCardDistance'
import { useCarregamentoVeiculoContext } from '../../../../../contexts/EntregaContext'

function MapaCarregamento({ dispatch, history, selectedTp }) {
  const { vehicles } = history.location.state
  const { periodo } = history.location.state

  const { state, localDispatch } = useMapaCarregamento()
  const { setCarregamentoVeiculoContext } = useCarregamentoVeiculoContext()

  useEffect(() => {
    if (selectedTp !== 0) {
      localDispatch.loadZonasEntrega(selectedTp)
      localDispatch.onInit(periodo)
    } else history.goBack()
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.LOAD_CUSTOMERS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        if (state.veiculos_carregados) {
          localDispatch.loadCustomersWithDeliveriesLoaded(
            selectedTp,
            state.dataPrevista,
            state.periodo.dataInicial,
            state.periodo.dataFinal,
          )
        } else {
          localDispatch.loadCustomersWithDeliveries(
            selectedTp,
            state.periodo.dataInicial,
            state.periodo.dataFinal,
          )
        }
        break

      case LOAD_MESSAGE.LOAD_CUSTOMERS_AFTER_UNLOAD:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.loadCustomersWithDeliveries(
          selectedTp,
          state.periodo.dataInicial,
          state.periodo.dataFinal,
          true,
        )
        break

      case LOAD_MESSAGE.GET_ASSOCIATED_DELIVERIES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getDeliveriesAssociatedToFleet(
          selectedTp,
          state.selectedVeiculo,
          state.dataPrevista,
        )
        break

      case LOAD_MESSAGE.SAVE_DELIVERIES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))

        localDispatch.saveDeliveriesToVehicle(
          selectedTp,
          localDispatch.buildAssociation(
            state.deliveriesToAssociate,
            state.selectedVeiculo,
            state.dataPrevista,
          ),
          state.dataPrevista,
          state.selectedVeiculo.vehicle_badge,
        )
        break

      case LOAD_MESSAGE.LOAD_DISTANCE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getRouteDistance(selectedTp, state.associatedDeliveries)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.veiculos_carregados) {
      localDispatch.loadCustomersWithDeliveriesLoaded(
        selectedTp,
        state.dataPrevista,
        state.periodo.dataInicial,
        state.periodo.dataFinal,
      )
    }
  }, [state.dataPrevista])

  useEffect(() => {
    if (state.activeIndex === 1) {
      localDispatch.loadCustomers()
    }
  }, [state.activeIndex])

  return (
    <div>
      <PageHeader>3.4 - Carregamento de Veículos de Entregas - Roteirização via Mapa</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-4">
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>
                Data de importação das Entregas:
              </label>
              <Periodo
                periodoInicial={state.periodo ? state.periodo.dataInicial : periodo.dataInicial}
                periodoFinal={state.periodo ? state.periodo.dataFinal : periodo.dataFinal}
                onPesquisar={(pInicial, pFinal) => {
                  setCarregamentoVeiculoContext(prev => ({
                    ...prev,
                    selectedPeriodo: { dataInicial: pInicial, dataFinal: pFinal },
                  }))
                  localDispatch.getCustomersWithDeliveries(pInicial, pFinal)
                }}
              />
            </div>
            <div className="p-col-2">
              <CustomCalendar
                marginTop={10}
                label="Data Prevista de Entrega"
                value={state.dataPrevista}
                onChange={value =>
                  localDispatch.onDataPrevistaChange(value, state.selectedVeiculo, selectedTp)
                }
              />
            </div>
            <div className="p-col-2">
              <CustomDropdown
                marginTop={10}
                filter={true}
                value={state.selectedVeiculo}
                label="Veículo"
                optionLabel="vehicle_badge"
                options={vehicles}
                onChange={value =>
                  localDispatch.onSelectedVeiculoChange(value, selectedTp, state.dataPrevista)
                }
              />
            </div>
            <div
              className="p-grid p-col-4"
              style={{ paddingRight: 0, marginLeft: 0, marginTop: 27 }}
            >
              <div className="p-col-2" style={{ width: 'fit-content' }}>
                <Btn onClick={localDispatch.onSalvarClick} disabled={state.isSaving}>
                  Salvar
                </Btn>
              </div>
              <div className="p-col-2" style={{ width: 'fit-content' }}>
                <Btn
                  onClick={() => localDispatch.onShowAssociatedDeliveries(state.selectedVeiculo)}
                >
                  Ver Entregas Associadas
                </Btn>
              </div>
            </div>
            <div
              className="p-col-2"
              style={{ display: 'flex', alignItems: 'center', justifyItems: 'center' }}
            >
              <CustomCheckbox
                checked={state.veiculos_carregados}
                onChange={() =>
                  localDispatch.onChangeVeiculosCarregados(!state.veiculos_carregados)
                }
              >
                Mostrar Veículos Carregados
              </CustomCheckbox>
            </div>
            <div className="p-col-2">
              {state.veiculos_carregados ? (
                <CustomMultiSelect
                  marginTop={10}
                  filter={true}
                  value={state.selectedVeiculoFilter}
                  label="Filtrar Veículo"
                  optionLabel="vehicles_badge"
                  options={state.vehiclesFilter}
                  onChange={value => localDispatch.onSelectedVeiculoFilterChange(value)}
                />
              ) : null}
            </div>
            <div className="p-col-8" />
            <div className="p-col-2">
              <CustomCardColorBar
                value={state.vehicleStats.steps}
                title={'Total de Paradas'}
                subTitle={`un`}
                barColor={vinho}
              />
            </div>
            <div className="p-col-2">
              <CustomCardColorBar
                value={state.vehicleStats.deliveries}
                title={'Total de Entregas'}
                subTitle={`un`}
                barColor={laranja}
              />
            </div>
            <div className="p-col-2">
              <CustomCardColorBar
                value={state.vehicleStats.qteSku}
                title={'Qte Volumes'}
                subTitle={`qte`}
                barColor={azul_escuro}
              />
            </div>
            <div className="p-col-2">
              <CustomCardColorBar
                value={
                  <NumeroDecimal decimalScale={2}>{state.vehicleStats.weight}</NumeroDecimal>
                }
                title={'Peso'}
                subTitle={`kg`}
                barColor={azul_hover}
              />
            </div>
            <div className="p-col-2">
              <CustomCardColorBar
                value={state.vehicleStats.ocupation.toFixed(2)}
                title={'Tx. Ocupação KG'}
                subTitle={`%`}
                barColor={pink}
              />
            </div>
            <div className="p-col-2">
              <CustomCardColorBar
                value={
                  state.vehicleStats.qtePallets ? Math.ceil(state.vehicleStats.qtePallets) : '-'
                }
                title={'Pallets'}
                subTitle={`qte`}
                barColor={gray}
              />
            </div>
            <div className="p-col-2">
              <CustomCardDistance
                value={
                  <NumeroDecimal decimalScale={0}>{state.vehicleStats.distance}</NumeroDecimal>
                }
                title={'Distância Total'}
                subTitle={`km`}
                barColor={vinho}
                btn={<Btn onClick={localDispatch.onClickLoadDistance}>Obter Distância</Btn>}
                selectedTp={selectedTp}
              />
            </div>
            <div className="p-col-2">
              <CustomCardColorBar
                value={
                  <NumeroDecimal decimalScale={2}>{state.vehicleStats.valor_nf}</NumeroDecimal>
                }
                title={'Faturamento'}
                subTitle={`R$`}
                barColor={laranja}
              />
            </div>
          </div>
          <Fieldset legend="Filtro" toggleable collapsed={true} className="p-col-12">
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Zona de Entrega"
                  options={state.zonasEntregaOptions}
                  value={state.selectedZonas}
                  onChange={zonas => localDispatch.setFilter('selectedZonas', zonas)}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Estados"
                  options={state.ufOptions}
                  value={state.selectedUfs}
                  onChange={ufs => localDispatch.setFilter('selectedUfs', ufs)}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Cidades"
                  options={state.citiesOptions}
                  value={state.selectedCities}
                  onChange={cities => localDispatch.setFilter('selectedCities', cities)}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Bairros"
                  options={state.bairrosOptions}
                  value={state.selectedBairros}
                  onChange={bairros => localDispatch.setFilter('selectedBairros', bairros)}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Info Complementar"
                  options={state.infoComplementarOptions}
                  value={state.selectedInfoComplementar}
                  onChange={infoComplementar =>
                    localDispatch.setFilter('selectedInfoComplementar', infoComplementar)
                  }
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Empresa"
                  options={state.empresasOptions}
                  value={state.selectedEmpresas}
                  onChange={empresas => localDispatch.setFilter('selectedEmpresas', empresas)}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomDropdown
                  label="Mostrar Reentregas"
                  options={[
                    { label: 'Sim', value: 12 },
                    { label: 'Não', value: false },
                    { label: 'Todos', value: null },
                  ]}
                  value={state.reentregaStatus}
                  onChange={value => localDispatch.setFilter('reentregaStatus', value)}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomDropdown
                  label="Entregas Agendadas"
                  options={[
                    { label: 'Sim', value: 'sim' },
                    { label: 'Não', value: 'nao' },
                    { label: 'Todos', value: null },
                  ]}
                  value={state.entregasAgendadasStatus}
                  onChange={value => localDispatch.setFilter('entregasAgendadasStatus', value)}
                />
              </div>
              <div className="p-col-2" style={{ minWidth: 200 }}>
                <CustomMultiSelect
                  marginTop={10}
                  label="Dt. Próx. Agendamento"
                  options={state.agendamentosOptions}
                  value={state.selectedAgendamentos}
                  onChange={agendamentos =>
                    localDispatch.setFilter('selectedAgendamentos', agendamentos)
                  }
                />
              </div>
              <div style={{ paddingTop: 27 , marginBottom: 10}}>
                    <Btn onClick={localDispatch.limparFiltros}>Limpar Filtros</Btn>
              </div>
              <div className="p-col-4" style={{ minWidth: 200 }}>
                <InputText
                  marginTop={10}
                  label="Beep NF"
                  value={state.beepNf}
                  onChange={value => localDispatch.setFilter('beepNf', value)}
                />
              </div>
            </div>
          </Fieldset>
          <CustomTabView activeIndex={state.activeIndex} onTabChange={localDispatch.onTabChange}>
            <TabPanel header="Roteirização Via Mapa">
              <RoteirizacaoMapa
                customers={state.customers}
                addDeliveriesToVehicle={localDispatch.addDeliveriesToAssociate}
                selectedVeiculo={state.selectedVeiculo}
                loadCounter={state.loadCounter}
                updateLoadCounter={localDispatch.updateLoadCounter}
              />
            </TabPanel>
            <TabPanel header="Clientes sem coordenadas">
              <ClienteSemCoordenada
                customers={state.customersWithoutCoordinates}
                onSave={() => {}}
              />
            </TabPanel>
          </CustomTabView>
        </CustomPanel>
      </div>
      <ModalDescarregarElement
        frota={state.frota}
        isVisible={state.showModalAssociatedDeliveries}
        hasOrdemCarregamento={true}
        onSaveOrdemCarregamento={localDispatch.onSaveOrdemCarregamento}
        onClose={localDispatch.onModalClose}
      />
    </div>
  )
}
const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MapaCarregamento))
